module.exports = __webpack_public_path__ + "static/21-5ecb1157aeb542881ab2375c076a5b47.jpg";